"use client";

import { RangerEvents } from "@/prisma/generated/browser";
import { Verified } from "@mui/icons-material";
import { Chip, Stack, TableCell, Typography } from "@mui/material";
import { format } from "date-fns";
import { useState } from "react";
import BookmarkEventButton from "../../buttons/BookmarkEventButton";
import ViewEventButton from "../../buttons/ViewEventButton";
import EventsDropdown from "../dropdowns/EventsDropdown";
import ResponsiveTableRow from "./ResponsiveTableRow";

export default function EventsTableRow({ event, mobile = false }: { event: RangerEvents; mobile?: boolean }) {
  const [open, setOpen] = useState(false);

  const topContent = (
    <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
      <Stack>
        <Typography sx={{ fontWeight: "bold" }}>{event.name}</Typography>
        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
          {event.city}, {event.country}
        </Typography>
      </Stack>
      <Chip label={format(event.date, "PP")} size="small" sx={{ mt: 0.5, width: "fit-content" }} />
    </Stack>
  );

  const actions = (
    <Stack direction="row" sx={{ justifyContent: "flex-end", alignItems: "center", gap: 1 }}>
      {event.official && (
        <Chip
          icon={<Verified sx={{ fontSize: "0.9rem !important" }} />}
          label="OFFICIAL"
          color="warning"
          size="small"
          sx={{ fontWeight: 700, fontSize: "0.7rem", height: 24 }}
        />
      )}
      <BookmarkEventButton eventId={event.id} />
      <ViewEventButton eventUuid={event.uuid} icon={false} size="small" />
    </Stack>
  );

  const dropdownContent = <EventsDropdown inline={mobile} event={event} open={open} />;

  return (
    <ResponsiveTableRow
      cardContent={topContent}
      actions={actions}
      tableCells={[
        <TableCell width={"50%"}>
          <a href={`/rangers/events/${event.uuid}`}>
            <Typography>{event.name}</Typography>
            <Typography variant="subtitle2">
              {event.city}, {event.country}
            </Typography>
            5
          </a>
        </TableCell>,
        <TableCell width={"20%"} align="left">
          {format(event.date, "PP")}
        </TableCell>
      ]}
      open={open}
      setOpen={setOpen}
      dropdownContent={dropdownContent}
      mobile={mobile}
      tableRowSx={{}}
      cardSx={{
        borderRight: event.official ? 5 : undefined,
        borderLeft: event.official ? 5 : undefined,
        borderRightColor: event.official ? "warning.main" : undefined,
        borderLeftColor: event.official ? "warning.main" : undefined,
        ...(event.official && {
          background:
            "linear-gradient(90deg, transparent 0%, rgba(255, 152, 0, 0.022) 20%, rgba(255, 152, 0, 0.022) 80%, transparent 100%)"
        })
      }}
    />
  );
}
